import { IFormData } from "./login-card.types";

export enum loginPhases {
  generateOTP = "generateOTP",
  validateOTP = "validateOTP"
}

export const formCardData: Record<string, IFormData> = {
  validateOTP: {
    heading: "Cek WhatsApp-mu",
    subHeading: "Masukkan kode yang dikirim lewat WhatsApp ke:"
  },
  generateOTP: {
    heading: "Masuk khusus murid bimbel",
    subHeading: "Ketik nomor HP yang digunakan untuk masuk kelas Bimbel CoLearn"
  }
};
